enum CollectionEnum {
  LABOUR = 'labour',
  PROCESSING = 'processing',
  EXPENSES = 'expenses',
  ADDITIONAL = 'additional',
}

export default CollectionEnum
